import { FC, PropsWithChildren } from 'react';
import { FlexGridColumn } from '../../../../../../ReactSharedScripts/components/FlexGrid';
import classes from './styles/listTileImageLayout.module.css';
import { isNullOrUndefined } from '../../../../../../ReactSharedScripts/predicates/type';

const ListTileImageLayout: FC<PropsWithChildren<{ backgroundImageUrl?: string }>> = ({
	children,
	backgroundImageUrl,
}) => {
	const styles: React.CSSProperties = {};

	if (!isNullOrUndefined(backgroundImageUrl)) {
		styles.backgroundImage = `url(${backgroundImageUrl})`;
	}

	return (
		<FlexGridColumn
			noGrow
			noShrink
			wrappedText
			className={classes.root}
			style={styles}
		>
			{children}
		</FlexGridColumn>
	);
};

export { ListTileImageLayout };
